import { useHasUserGroups } from '#app/hooks/useHasUserGroups.js';
import { useMemo } from 'react';

type Fields = Array<{
  isCurrentValueEmpty: () => boolean;
  setValue: () => void;
}>;

export const useDemoUserPrefill = (fields: Fields) => {
  const isDemoUser = useHasUserGroups('MANUAL_DEMO_USER');

  const handlers = useMemo(() => {
    const lambdas = fields.map(({ isCurrentValueEmpty, setValue }) => () => {
      if (isCurrentValueEmpty()) {
        setValue();
      }
    });
    return lambdas;
  }, [fields]);

  if (!isDemoUser) {
    return [];
  }

  return handlers;
};
